import {
    CoworkingVisual,
    MeetingRoomVisual,
    PremiumCabinVisual,
    PrivateCabinVisual,
} from "@/components/workspaces/WorkspaceVisuals";
import { SoloVignette } from "@/components/audience/AudienceVignettes";
import { CoffeeBreakoutVisual, ReceptionVisual } from "@/components/gallery/GalleryVisuals";

export const GALLERY_CATEGORIES = ["Coworking", "Private Cabins", "Premium Cabins", "Meeting Room", "Facilities"];

export const VISUAL_MAP = {
    coworking: CoworkingVisual,
    private: PrivateCabinVisual,
    premium: PremiumCabinVisual,
    meeting: MeetingRoomVisual,
    solo: SoloVignette,
    coffee: CoffeeBreakoutVisual,
    reception: ReceptionVisual,
};

export const VISUAL_OPTIONS = [
    { key: "coworking", label: "Coworking Floor (illustration)" },
    { key: "private", label: "Private Cabin (illustration)" },
    { key: "premium", label: "Premium Cabin (illustration)" },
    { key: "meeting", label: "Meeting Room (illustration)" },
    { key: "solo", label: "Focus Desk (illustration)" },
    { key: "coffee", label: "Coffee & Breakout (illustration)" },
    { key: "reception", label: "Reception (illustration)" },
];

export const fileUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
